// Shared haptic-feedback helper, matching the pattern already used in
// minimal-steps-card.jsx. Silently no-ops on platforms without vibration
// support (desktop browsers, iOS Safari) — navigator.vibrate is
// Android-Chrome-only today, so this is a progressive enhancement, not a
// guaranteed effect.
export const triggerHaptic = (durationMs = 8) => {
  if (typeof window !== "undefined" && window?.navigator?.vibrate) {
    window.navigator.vibrate(durationMs)
  }
}